import { render, staticRenderFns } from "./WebHeader.vue?vue&type=template&id=3b0afb1c&"
import script from "./WebHeader.vue?vue&type=script&lang=js&"
export * from "./WebHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports